module.exports = __webpack_public_path__ + "9ba1d39ec22e3bcfbe8c0e4bdef709be.svg";